var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UIController from '../ui';
import toHighlightCategory from '../utilities/toHighlightCategory';
export default class CategoryItem {
    constructor(category, categoryId) {
        this.category = category;
        this.categoryId = categoryId;
    }
    render() {
        return __awaiter(this, void 0, void 0, function* () {
            // create the element
            const li = document.createElement('li');
            const module = yield import(`../../images/${this.category.toLowerCase()}.svg`);
            li.id = this.categoryId;
            li.classList.add('nav_options_item');
            li.innerHTML = `
            <img src='${module.default}' alt="${this.category.toLowerCase()}" title="${this.category}" data-categoryid="${this.categoryId}" />
            ${this.category}
        `;
            // attach onlick event listener
            li.onclick = () => {
                toHighlightCategory(this.categoryId);
                UIController.renderRecipeCardsByCat(this.category);
            };
            // return the element
            return li;
        });
    }
}
